import {
  Home,
  Dumbbell,
  Apple,
  TrendingUp,
  BarChart3,
  User,
  Settings,
  Users,
  FileText,
  Upload,
  Info,
  Archive,
  StickyNote,
  Building2,
  Heart,
  Target
} from 'lucide-react'

// Icon mapping for navigation menu items
export const iconMap = {
  // Client-side navigation icons
  'composition': BarChart3,
  'composition.svg': BarChart3,
  'nutrition': Apple,
  'nutrition.svg': Apple,
  'exercise': Dumbbell,
  'exercise.svg': Dumbbell,
  'history': Archive,
  'history.svg': Archive,
  'archive': Archive,
  
  // Admin/Consultant navigation icons
  'people_outline': Users,
  'people': Users,
  'resources': FileText,
  'resources.svg': FileText,
  'file_upload_outline': Upload,
  'file_upload': Upload,
  'info': Info,
  'settings_outline': Settings,
  'settings': Settings,
  'notes': StickyNote,
  'notes.svg': StickyNote,
  'exercise_plan_builder': Target,
  'plan_builder': Target,
  'workout_builder': Target,
  
  // Fallback icons
  'dashboard': Home,
  'home': Home,
  'user': User,
  'users': Users,
  'building': Building2,
  'heart': Heart,
  'health': Heart,
  
  // Default fallback
  'default': Home
}

// Function to get icon component by name
export const getIconComponent = (iconName) => {
  if (!iconName) return iconMap.default
  
  // Try exact match first
  if (iconMap[iconName]) {
    return iconMap[iconName]
  }
  
  // Try lowercase match
  const lowerName = iconName.toLowerCase()
  if (iconMap[lowerName]) {
    return iconMap[lowerName]
  }
  
  // Try without file extension
  const nameWithoutExt = iconName.replace(/\.(svg|png|jpg|jpeg)$/i, '')
  if (iconMap[nameWithoutExt]) {
    return iconMap[nameWithoutExt]
  }
  
  // Return default icon
  return iconMap.default
}

// Navigation route mapping based on the provided site menu API response
export const routeMapping = {
  // Client routes
  'Composition': '/clientcomposition',
  'Nutrition': '/clientnutrition', 
  'Exercise': '/clientexercise',
  'Resources': '/resources',
  'Program archive': '/clientprogramarchive',
  'Program Binder': '/program-binder',
  
  // Consultant/Admin routes
  'Clients': '/consultant-clients',
  'Exercise Plan Builder': '/exercise-plan-builder',
  'Plan Builder': '/exercise-plan-builder',
  'Workout Builder': '/exercise-plan-builder',
  'Resources': '/resources', // Note: This might conflict with client resources
  'Uploader': '/uploader',
  'Prospects': '/prospects',
  'Platform Setup': '/platform-setup',
  'Users': '/company-clients',
  'Consultant Notes': '/consultant-notes',
  'User Upload': '/userupload'
}

// Component mapping for dynamic imports
export const componentMapping = {
  'clientcomposition': () => import('@/pages/client/ClientComposition'),
  'clientnutrition': () => import('@/pages/client/ClientNutrition'),
  'clientexercise': () => import('@/pages/client/ClientExercise'),
  'clientresources': () => import('@/pages/client/ClientResources'),
  'clientprogramarchive': () => import('@/pages/client/ClientProgramArchive'),
  'consultant-clients': () => import('@/pages/consultant/ConsultantClients'),
  'exercise-plan-builder': () => import('@/pages/consultant/ExercisePlanBuilder'),
  'resources': () => import('@/pages/admin/Resources'),
  'uploader': () => import('@/pages/admin/Uploader'),
  'prospects': () => import('@/pages/admin/Prospects'),
  'platform-setup': () => import('@/pages/admin/PlatformSetup'),
  'company-clients': () => import('@/pages/admin/CompanyClients'),
  'consultant-notes': () => import('@/pages/consultant/ConsultantNotes'),
  'notes': () => import('@/pages/admin/Notes'),
  'userupload': () => import('@/pages/admin/UserUpload'),
  'site-settings': () => import('@/pages/admin/SiteSettings')
}

export default {
  iconMap,
  getIconComponent,
  routeMapping,
  componentMapping
}
